// Shared answers for the homepage and FAQ page.
export const homeFaq = {
  "it": [
    [
      "Perché partecipare se ho già un sito o i social?",
      "PlantAdopting affianca i tuoi canali con una scheda collegata al territorio, alle attività e al patrimonio vivente: colture, piante, animali, produzioni e opportunità. Aiuta chi esplora a capire cosa fai e come contattarti."
    ],
    [
      "Cosa posso fare gratuitamente?",
      "L’account personale è gratuito. Con Free puoi presentare la realtà che rappresenti nell’Atlante, con contatti, cataloghi, un prodotto o produzione e un marchio. Solo Comuni ed enti pubblici hanno anche un progetto incluso. Pro costa 50 €/anno, IVA inclusa, e comprende fino a 100 prodotti e 100 opportunità complessive, progetti inclusi."
    ],
    [
      "Come rendo visibile la mia scheda?",
      "Crea il tuo account personale, aggiungi la realtà che sei autorizzato a rappresentare o gestire, poi completa e salva la scheda: sarà consultabile nell’Atlante. Account e scheda sono distinti; non occorre un ulteriore passaggio di pubblicazione."
    ]
  ],
  "en": [
    [
      "Why join if I already have a website or social media?",
      "PlantAdopting complements your channels with a profile connected to your location, activities and living heritage: crops, plants, animals, products and opportunities. It helps visitors understand what you do and how to contact you."
    ],
    [
      "What can I do for free?",
      "Your personal account is free. Free lets you present the organization or place you represent in the Atlas, with contacts, catalogs, one product or production and one brand. Only municipalities and public bodies also have one included project. Pro costs €50/year, including VAT, with up to 100 products and 100 opportunities in total, including projects."
    ],
    [
      "How do I make my profile visible?",
      "Create your personal account, add the organization or place you are authorized to represent or manage, then complete and save the profile: it will be available in the Atlas. Accounts and profiles are separate; no additional publishing step is needed."
    ]
  ]
};
